import { render, staticRenderFns } from "./PositionSet.vue?vue&type=template&id=4fb69f04&scoped=true&"
import script from "./PositionSet.vue?vue&type=script&lang=js&"
export * from "./PositionSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb69f04",
  null
  
)

export default component.exports